export default __webpack_public_path__ + "static/media/dinner.6de8a4d4.svg";